export enum THGPromotionStatus {
    PAID_OUT = 'paid-out',
    OPEN = 'open',
}
